<script>
export default {
  name: "ModalHelp",
  delimiters: ["[[", "]]"],
  props: {
    title: String,
    text: String,
  },
  template:`
  <div class="help-modal active" v-on:click="closeModal">
    <div class="help-modal-container">
      <div class="help-modal-body">
        <div class="help-modal-close">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.9999 1.99983L2 17.9997" stroke="#2B1B35" stroke-width="2.25" stroke-miterlimit="10"
                  stroke-linecap="round"/>
            <path d="M18.0001 18L2.00024 2.00009" stroke="#2B1B35" stroke-width="2.25" stroke-miterlimit="10"
                  stroke-linecap="round"/>
          </svg>
        </div>
        <div class="help-modal-big">[[ title ]]</div>
        <div class="help-modal-text">[[ text ]]</div>
      </div>
    </div>
  </div>
  `,
  methods: {
    closeModal: function () {
      this.$emit("hideHelp");
    },
  },
}
</script>

<style>
.help-button {
    margin-top: 28px;
    max-width: 240px;
    display: inline-block !important;
}
.help-modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: auto;
    background: #00000045;
    display: none;
    z-index: 99;
    text-align:center;
}
.help-modal.active {
    display: block;
}

.help-modal-container {
  height: 117px;
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  right: auto;
  width: 90%;
  max-width: 600px;
  transform: translate(-50%, -50%);
}

.help-modal-body {
    padding: 56px 19px 32px 16px;
    margin: 0 auto;
    max-width: 544px;
    background: #fff;
    border-radius: 20px;
}
.help-modal-close {
  position: absolute;
  right: 16px;
    top: 16px;
    transition: opacity .3s ease;
    cursor: pointer;
    opacity: 0.5;
}
.help-modal-big {
  font-family: var(--font-family-b);
  font-size: 20px;
  line-height: 24px;
  text-align: left;
}
.help-modal-text {
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  margin-top: 8px;
}
.help-modal-text:first-child{
  margin-top: 0;
}
@media (min-width: 600px) {
  .help-modal-close {
    right: 46px;
    top: 16px;
  }
}
</style>